import RouteView from "@/layouts/RouteView.vue";
export default {
  path: "/groupOrder",
  name: "groupOrder",
  redirect: "/groupOrder/page",
  component: RouteView,
  meta: {
    title: "订单管理",
    isGroup: true,
    showNavBar: false,
  },
  children: [
    {
      path: "/groupOrder/page",
      name: "GroupPage",

      component: () =>
        import(/* webpackChunkName: "groupOrder" */ "@/views/groupOrder/Page.vue"),
      meta: {
        title: "订单管理",
        isGroup: true,
        showNavBar: true,
      },
    },
    {
      path: "/groupOrder/Detail",
      name: "GroupOrderDetail",
      component: () =>
        import(/* webpackChunkName: "groupOrder" */ "@/views/groupOrder/Detail.vue"),
      meta: {
        title: "订单详情",
        isGroup: true,
        showNavBar: false,
      },
    },
    {
      path: "/groupOrder/OrderLog",
      name: "GroupOrderLog",
      component: () =>
        import(/* webpackChunkName: "groupOrder" */ "@/views/groupOrder/OrderLog.vue"),
      meta: {
        title: "订单日志",
        isGroup: true,
        showNavBar: false,
      },
    },
  ],
};
